
export default {
  name: 'DrinkCard',

  props: {
    href: { type: String, default: null },
    background: { type: String, default: null },
  },
}
